<template>
    <!-- footer -->
    <footer class="footer">
        <div class="container">
            <div class="row">
                <div class="col-12">
                    <div class="footer__content">
                        <router-link to="/" class="footer__logo">
                            <img src="../../assets/img/mtn-new-logo.svg" alt="">
                        </router-link>

                        <span class="footer__copyright">© Trend, {{ year }} <br> Create by <a
                                href="https://byte-team.com/" target="_blank">Byte Co.Ltd</a></span>

                        <nav class="footer__nav">
                            <!-- <router-link to="/" >About Us</router-link> -->
                            <router-link to="/contacts" >اتصل بنا</router-link>
                            <!-- <a href="privacy.html">Privacy policy</a> -->
                        </nav>

                        <button class="footer__back" type="button">
                            <i class="ti ti-arrow-narrow-up"></i>
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </footer>
    <!-- end footer -->
</template>

<script>
export default {
    name: 'AppFooter',
    data() {
        return {
            year: new Date().getFullYear()
        }
    }
}
</script>

<style></style>